<template lang="pug">
#diagnostico-socioambiental(style='height: fit-content')
    el-collapse(v-model='indexCollapseRow', :accordion='!inspecionar')
        div(v-if='this.dadosConsulta && this.dadosConsulta.protocoloDescricao')
            .d-flex.align-items-center(style='height: 40px')
                b.font_weight_bold {{ $t('mensagens.diagnosticoSocioambiental.protocoloUtilizado') }}
                i.mdi.mdi-information-outline(
                    style='width: 25px; text-align: center;',
                    slot='suffix',
                    :title="$t('mensagens.blocoFiltros.infos.selecionarProtocoloParaDiagnostico')"
                )
            span {{ this.dadosConsulta.protocoloDescricao }}
        br
        .tooltop-container(v-if='getCamadasForaDaRegiao().length > 0')
            el-tooltip.tooltip-camadas(effect='light', placement='right')
                span(slot='content')
                    h3 {{ $t('mensagens.monitoramentoSocioambiental.criteriosTitulo') }}
                    p.tooltip-content
                        span {{ $t('mensagens.diagnosticoSocioambiental.spanProtocolo') }}
                    p
                        strong {{ $t('mensagens.monitoramentoSocioambiental.camadas') }}:
                    p.camadas-fora-regiao(v-for='diagnostico in getCamadasForaDaRegiao()' v-html='definirNomeCamada(diagnostico)')
                span
                    i.information-card.mdi.mdi-information-outline.criterio-fora-regiao.icone
                    span {{ $t('mensagens.diagnosticoSocioambiental.visualizarDetalhes') }}

        el-collapse-item(
            v-for='(diagnostico, index) in getDiagnosticos()',
            v-if='showLayer(diagnostico)',
            :name='index'
        )
            template(slot='title')
                div(v-if='!inspecionar').icons-position
                    i.mr-2.el-icon-remove-outline.custon-icon-el(
                        v-if='diagnostico.status && diagnostico.status === "ERROR"'
                    )
                    i.mr-2.flow.flow-verified.verde.mr8.custon-icon(
                        v-else-if='(diagnostico.nivelAlerta && diagnostico.nivelAlerta === "BAIXO") || (!diagnostico.nivelAlerta && diagnostico.resultados.length === 0)'
                    )
                    i.mr-2.flow.flow-warning-sign.amarelo.mr8.custon-icon(
                        v-else-if='diagnostico.nivelAlerta && diagnostico.nivelAlerta === "MEDIO"'
                    )
                    i.mr-2.flow.flow-warning-sign.vermelho.mr8.custon-icon(
                        v-else='(diagnostico.nivelAlerta && diagnostico.nivelAlerta === "ALTO") || (!diagnostico.nivelAlerta)'
                    )
                    el-checkbox.mt-2(
                        v-if='habilitarInibicao(diagnostico.nivelAlerta) && existeRestricaoNaoInibida(diagnostico) && verificaPerfilBotaoInibir()',
                        :indeterminate='diagnostico.todasRestricoesIndeterminadas',
                        :key='index',
                        v-model='diagnostico.marcarTodasRestricoes',
                        @change='marcarTodasRestricoes(diagnostico)'
                    )
                .checkbox-container(
                    :style='habilitarInibicao(diagnostico.nivelAlerta) && existeRestricaoNaoInibida(diagnostico) ? "margin-left: 2%" : ""'
                )
                    span(
                        :class='montaClasseCamada(inspecionar, habilitarSinalAviso)', v-html='definirNomeCamada(diagnostico)'
                    )
                div(v-if="diagnostico.resultados.length && !(diagnostico.resultados.length === 1 && diagnostico.resultados[0].id === null)")
                    el-tag.custon-tag(
                        v-if='diagnostico.nivelAlerta && diagnostico.nivelAlerta === "BAIXO"',
                        size='mini',
                        type='success'
                    ) {{ diagnostico.resultados.length }}
                    el-tag.custon-tag(
                        v-else-if='diagnostico.nivelAlerta && diagnostico.nivelAlerta === "MEDIO"',
                        size='mini',
                        type='warning'
                    ) {{ diagnostico.resultados.length }}
                    el-tag.custon-tag(v-else, size='mini', type='danger') {{ diagnostico.resultados.length }}
                
                div(v-if="verificarRestricaoInibidaAutomaticamente(diagnostico)")
                    span &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                    span(class='tag-inibido-automaticamente') {{ $t('mensagens.operacao.tagInibicaoAutomatica') }}

            div(v-if='showLayerResults(diagnostico)')
                .card-opacidade(v-if='podeHabilitarOpacidade(diagnostico)')
                    .opacidade
                        span {{ $t('mensagens.diagnosticoSocioambiental.opacidade') }}:
                        el-slider(
                            v-model='diagnostico.camada.opacidade',
                            @change='atualizarOpacidade(diagnostico.camada.opacidade)'
                        )

                component(
                    ref='componente',
                    v-bind:is='diagnostico.component',
                    v-bind='getProperties(diagnostico)',
                    @aplicar-zoom-restricao='aplicarZoomRestricao'
                )
                    template(
                        v-if='habilitarInibicao(diagnostico.nivelAlerta)',
                        v-slot:botaoInibir='{ restricao }'
                    )
                            .container-justificativa(
                                v-if='verificaPerfilBotaoJustificativa() && ehRestricaoInibida(restricao)'
                            )
                                div.container-botoes
                                    BaseButton(
                                        icon='el-icon-view',
                                        @click='inibirRestricao(restricao, diagnostico)',
                                        type='primary',
                                        size='mini'
                                    ) {{ $t('mensagens.diagnosticoSocioambiental.inibidoEm') + formatarData(restricao.dataInibido) }}
                                    BaseButton(
                                        icon='el-icon-edit',
                                        @click='$emit("editar-justificativa", restricao, diagnostico)',
                                        size='mini'
                                    ) {{ $t('mensagens.comuns.editar') }}

                    template(
                        v-if='habilitarInibicao(diagnostico.nivelAlerta) && verificaPerfilBotaoInibir()',
                        v-slot:selecionarRestricao='{ restricao }'
                    )
                        .botao-inibir-restricao(v-if='exibirBotaoInibir(restricao)')
                            BaseButton(
                                v-if='verificaPerfilBotaoInibir()',
                                :class='!ehRestricaoInibida(restricao) ? "botao-inibir-restricao--nao-inibido" : ""',
                                @click='inibirRestricao(restricao, diagnostico)',
                                type='primary',
                                size='mini'
                            ) {{ $t('mensagens.diagnosticoSocioambiental.inibir') }}
                            el-checkbox.mr-2.checkbox-adjust(
                                v-model='restricao.selecionado',
                                @change='marcarRestricaoParaInibir(diagnostico)'
                            )

                .botao-inibir-em-lote(
                    v-if='habilitarInibicao(diagnostico.nivelAlerta) && existeRestricaoNaoInibida(diagnostico) && verificaPerfilBotaoInibir()'
                )
                    BaseButton(
                        type='primary',
                        @click='inibirRestricoesEmLote(diagnostico)',
                        size='mini'
                    ) {{ $t('mensagens.diagnosticoSocioambiental.inibirRestricoesSelecionadas') }}

            .container-restricao(v-if='diagnostico.status && diagnostico.status === "ERROR"')
                p {{ $t('mensagens.diagnosticoSocioambiental.erro.naoFoiPossivelConsultarResultadosCriterio') }}

            .container-restricao(v-else-if="diagnostico.resultados.length === 0 || (diagnostico.resultados.length === 1 && diagnostico.resultados[0].id === null)")
                p {{ $t('mensagens.diagnosticoSocioambiental.naoHaRestricoes') }}

            Fonte(
                :fonte='diagnostico.camada.fonte || { dataCadastro: "-", nome: "-", url: "-" }'
            )
            p.text-right.text-info(
                @click="openIbamaNewTab",
                v-if='cpfCnpj && (diagnostico.camada.codigo === "AREA_EMBARGADA" || diagnostico.camada.codigo === "LISTA_AREA_EMBARGADA")'
            )
                span.link-button(style='cursor: pointer') {{ $t('mensagens.diagnosticoSocioambiental.consultarCertidaoIbama') }}
                    i.lyra-seguir-link.ml-3

            p.text-right.text-info(
                @click="getCertidaoLdi",
                v-if='car && diagnostico.camada.codigo === "LDI"'
            )
                span.link-button(style='cursor: pointer') {{ $t('mensagens.diagnosticoSocioambiental.consultarCertidao') }}
                    i.lyra-seguir-link.ml-3

        el-empty(
            v-if='!possuiResultados',
            :description='$t("mensagens.menuSig.semInformacoesCamadasSelecionadas")'
        )
</template>

<script>
import TerraIndigena from '@/components/diagnosticoSocioambiental/TerraIndigena.vue';
import PyLocalidadeNivel1 from '@/components/diagnosticoSocioambiental/DepartamentoParaguai.vue';
import PyLocalidadeNivel2 from '@/components/diagnosticoSocioambiental/LocalidadeParaguai.vue';
import TerraIndigenaParaguai from '@/components/diagnosticoSocioambiental/TerraIndigenaParaguai.vue';
import AmazoniaProtege from '@/components/diagnosticoSocioambiental/AmazoniaProtege.vue';
import AreaEmbargada from '@/components/diagnosticoSocioambiental/AreaEmbargada.vue';
import Prodes from '@/components/diagnosticoSocioambiental/Prodes.vue';
import AreaEmbargadaIcmbio from '@/components/diagnosticoSocioambiental/AreaEmbargadaIcmbio.vue';
import AreaEmbargadaSemaMt from '@/components/diagnosticoSocioambiental/AreaEmbargadaSemaMt.vue';
import AreaEmbargadaGoias from '@/components/diagnosticoSocioambiental/AreaEmbargadaGOIAS';
import MoratoriaSoja from '@/components/diagnosticoSocioambiental/MoratoriaSoja.vue';
import MoratoriaSojaPontos from '@/components/diagnosticoSocioambiental/MoratoriaSojaPontos.vue';
import AreaPlantadaSojaSafra2024 from '@/components/diagnosticoSocioambiental/AreaPlantadaSojaSafra2024.vue';
import PovosComunidadesTradicionais from '@/components/diagnosticoSocioambiental/PovosComunidadesTradicionais.vue';
import Ldi from '@/components/diagnosticoSocioambiental/Ldi.vue';
import ListaAreaEmbargada from '@/components/diagnosticoSocioambiental/ListaAreaEmbargada.vue';
import ProtocoloVerdeGraos from '@/components/diagnosticoSocioambiental/ProtocoloVerdeGraos.vue';
import ListaSujaTrabalhoEscravo from '@/components/diagnosticoSocioambiental/ListaSujaTrabalhoEscravo.vue';
import HistoricoListaSujaTrabalhoEscravo from '@/components/diagnosticoSocioambiental/HistoricoListaSujaTrabalhoEscravo.vue';
import MmaProdesBiomas from '@/components/diagnosticoSocioambiental/MmaProdesBiomas.vue';
import ListaMmaProdesCar from '@/components/diagnosticoSocioambiental/ListaMmaProdesCar.vue';
import ProdesCerrado from '@/components/diagnosticoSocioambiental/ProdesCerrado.vue';
import DeterAmazonia from '@/components/diagnosticoSocioambiental/DeterAmazonia.vue';
import DeterAmazoniaLegalNaoFloresta from '@/components/diagnosticoSocioambiental/DeterAmazoniaLegalNaoFloresta.vue';
import DeterCerrado from '@/components/diagnosticoSocioambiental/DeterCerrado.vue';
import DeterPantanal from '@/components/diagnosticoSocioambiental/DeterPantanal.vue';
import UnidadeConservacaoUs from '@/components/diagnosticoSocioambiental/UnidadeConservacaoUs.vue';
import UnidadeConservacaoPi from '@/components/diagnosticoSocioambiental/UnidadeConservacaoPi.vue';
import ZonaAmortecimentoUnidadeConservacaoPi from '@/components/diagnosticoSocioambiental/ZonaAmortecimentoUnidadeConservacaoPi.vue';
import Queimadas from '@/components/diagnosticoSocioambiental/Queimadas.vue';
import SitiosArqueologicos from '@/components/diagnosticoSocioambiental/SitiosArqueologicos.vue';
import FaixaFronteira from '@/components/diagnosticoSocioambiental/FaixaFronteira.vue';
import PocAreaPlantadaGameleira from '@/components/diagnosticoSocioambiental/PocAreaPlantadaGameleira.vue';
import ImovelRural from '@/components/diagnosticoSocioambiental/ImovelRural.vue';
import SituacaoCar from '@/components/diagnosticoSocioambiental/SituacaoCar.vue';
import Biomas from '@/components/diagnosticoSocioambiental/Biomas.vue';
import IncraSigefPublico from '@/components/diagnosticoSocioambiental/IncraSigefPublico.vue';
import IncraSigefPrivado from '@/components/diagnosticoSocioambiental/IncraSigefPrivado.vue';
import IncraAssentamentos from '@/components/diagnosticoSocioambiental/IncraAssentamentos.vue';
import IncraQuilombolas from '@/components/diagnosticoSocioambiental/IncraQuilombolas.vue';
import ElegibilidadeRenovabio from '@/components/diagnosticoSocioambiental/ElegibilidadeRenovabio.vue';
import DesmatamentoMapbiomas from '@/components/diagnosticoSocioambiental/desmatamento-mapbiomas.vue';
import DesmatamentoMapbiomasSad from '@/components/diagnosticoSocioambiental/DesmatamentoMapbiomasSad.vue';
import Fonte from '@/components/diagnosticoSocioambiental/Fonte.vue';
import AreaRelevanteInteresseEcologicoArie from '@/components/diagnosticoSocioambiental/AreaRelevanteInteresseEcologicoArie.vue';
import AreaProtecaoAmbientalApa from '@/components/diagnosticoSocioambiental/AreaProtecaoAmbientalApa.vue';
import AppCamada from '@/components/diagnosticoSocioambiental/AppCamada.vue';
import ReservaLegal from '@/components/diagnosticoSocioambiental/ReservaLegal.vue';
import UnidadeConservacao from '@/components/diagnosticoSocioambiental/UnidadeConservacao.vue';
import AreaPlantadaSojaCarMapbiomas from '@/components/diagnosticoSocioambiental/AreaPlantadaSojaCarMapbiomas.vue';
import AutoInfracaoSigamSp from '@/components/diagnosticoSocioambiental/AutoInfracaoSigamSp.vue';
import FundacaoPalmares from '@/components/diagnosticoSocioambiental/FundacaoPalmares.vue';
import AreasPrioritarias from '@/components/diagnosticoSocioambiental/AreasPrioritarias.vue';
import MonitoramentoDesmatamento from '@/components/diagnosticoSocioambiental/MonitoramentoDesmatamento.vue';
import AreaEmbargadaSedamRo from '@/components/diagnosticoSocioambiental/AreaEmbargadaSedamRo.vue';
import AreaEmbargadaRo from '@/components/diagnosticoSocioambiental/AreaEmbargadaRo.vue';
import AreaEmbargadaRoPonto from '@/components/diagnosticoSocioambiental/AreaEmbargadaRoPonto.vue';
import PlantioSoja23Matopiba from '@/components/diagnosticoSocioambiental/PlantioSoja23Matopiba.vue';
import SojaParaguai from '@/components/diagnosticoSocioambiental/SojaParaguai.vue';
import RecursoNaturalParaguai from '@/components/diagnosticoSocioambiental/RecursoNaturalParaguai.vue';
import ConformidadeSocioambientalParaguai from '@/components/diagnosticoSocioambiental/ConformidadeSocioambientalParaguai.vue';
import DesmatamentoInfonaParaguai from '@/components/diagnosticoSocioambiental/DesmatamentoInfonaParaguai.vue';
import AreasSilvestresProtegidasParaguai from '@/components/diagnosticoSocioambiental/AreasSilvestresProtegidasParaguai.vue';
import ListaAreaEmbargadaPiaui from '@/components/diagnosticoSocioambiental/ListaAreaEmbargadaPiaui.vue';
import FlorestasPublicas from '@/components/diagnosticoSocioambiental/FlorestasPublicas.vue';
import AreaEmbargadaPiaui from '@/components/diagnosticoSocioambiental/AreaEmbargadaPiaui.vue';
import AreaEmbargadaParana from '@/components/diagnosticoSocioambiental/AreaEmbargadaParana.vue';
import ProdesCaatinga from '@/components/diagnosticoSocioambiental/ProdesCaatinga.vue';
import ProdesMataAtlantica from '@/components/diagnosticoSocioambiental/ProdesMataAtlantica.vue';
import ProdesPampa from '@/components/diagnosticoSocioambiental/ProdesPampa.vue';
import ProdesPantanal from '@/components/diagnosticoSocioambiental/ProdesPantanal.vue';
import AreaEmbargadaSigaMtPoligono from '@/components/diagnosticoSocioambiental/AreaEmbargadaSigaMtPoligono.vue';
import AreaEmbargadaSigaMtPonto from '@/components/diagnosticoSocioambiental/AreaEmbargadaSigaMtPonto.vue';
import ListaAreaEmbargadaSemaMt from '@/components/diagnosticoSocioambiental/ListaAreaEmbargadaSemaMt.vue';
import ProdesResiduos from '@/components/diagnosticoSocioambiental/ProdesResiduos.vue';
import ProdesResiduosAmazonia from '@/components/diagnosticoSocioambiental/ProdesResiduosAmazonia.vue';
import ProdesResiduosCaatinga from '@/components/diagnosticoSocioambiental/ProdesResiduosCaatinga.vue';
import ProdesResiduosCerrado from '@/components/diagnosticoSocioambiental/ProdesResiduosCerrado.vue';
import ProdesResiduosMataAtlantica from '@/components/diagnosticoSocioambiental/ProdesResiduosMataAtlantica.vue';
import ProdesResiduosPampa from '@/components/diagnosticoSocioambiental/ProdesResiduosPampa.vue';
import ProdesResiduosPantanal from '@/components/diagnosticoSocioambiental/ProdesResiduosPantanal.vue';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

import DesmatamentoEudr from '@/components/diagnosticoSocioambiental/DesmatamentoEudr.vue';
import ArLocalidadeNivel1 from '@/components/diagnosticoSocioambiental/ProvinciaArgentina.vue';
import ArLocalidadeNivel2 from '@/components/diagnosticoSocioambiental/DepartamentoArgentina.vue';
import BrLocalidadeNivel1 from '@/components/diagnosticoSocioambiental/EstadoBrasil.vue';
import BrLocalidadeNivel2 from '@/components/diagnosticoSocioambiental/MunicipioBrasil.vue';
import DesmatamentoGfwParaguai from '@/components/diagnosticoSocioambiental/DesmatamentoGfwParaguai.vue';
import Soja2022DesmatamentoInfonaParaguai from '@/components/diagnosticoSocioambiental/Soja2022DesmatamentoInfonaParaguai.vue';
import Soja2022AreasProtegidasParaguai from '@/components/diagnosticoSocioambiental/Soja2022AreasProtegidasParaguai.vue';
import Soja2022ReservaBiosferaParaguai from '@/components/diagnosticoSocioambiental/Soja2022ReservaBiosferaParaguai.vue';
import Soja2022TerrasIndigenasParaguai from '@/components/diagnosticoSocioambiental/Soja2022TerrasIndigenasParaguai.vue';
import Soja2022SitiosRamsarParaguai from '@/components/diagnosticoSocioambiental/Soja2022SitiosRamsarParaguai.vue';
import AreaEmbargadaIbamaPoligonoPamgia from '@/components/diagnosticoSocioambiental/AreaEmbargadaIbamaPoligonoPamgia.vue';

import { camadasDiagnostico } from '@/constants/DiagnosticoSocioAmbientalCamadas';
import { CamadasService } from '@/services/CamadasService';
import { mapGetters } from 'vuex';
import { connect, subscribe, disconnect } from '@/utils/websocket';

import CertidaoIbamaService from '@/services/CertidaoIbamaService';

import EventBus from '@/utils/eventBus';

// O nome dos componentes (arquivos) de camadas devem seguir o codigo da camada em CamelCase
// Exemplo do arquivo: camada codigo SIGEF_PUBLICO = SigefPublico.vue
// O atributo name dos componentes deve ser o codigo da camada separado por -
// Exemplo do name: camada codigo SIGEF_PUBLICO = sigef-publico

export default {
    name: 'DiagnosticoSocioambiental',

    emits: ['index-aberto', 'inibir-restricao', 'inibir-restricoes-em-lote'],

    components: {
        SituacaoCar,
        TerraIndigena,
        PyLocalidadeNivel1,
        PyLocalidadeNivel2,
        TerraIndigenaParaguai,
        AmazoniaProtege,
        AreaEmbargada,
        Prodes,
        AreaEmbargadaIcmbio,
        AreaEmbargadaSemaMt,
        AreaEmbargadaGoias,
        AreaEmbargadaPiaui,
        AreaEmbargadaParana,
        MoratoriaSoja,
        MoratoriaSojaPontos,
        AreaPlantadaSojaSafra2024,
        PovosComunidadesTradicionais,
        Ldi,
        ListaAreaEmbargada,
        ProtocoloVerdeGraos,
        ListaSujaTrabalhoEscravo,
        HistoricoListaSujaTrabalhoEscravo,
        MmaProdesBiomas,
        ListaMmaProdesCar,
        ProdesCerrado,
        DeterAmazonia,
        DeterAmazoniaLegalNaoFloresta,
        DeterCerrado,
        DeterPantanal,
        UnidadeConservacaoUs,
        UnidadeConservacaoPi,
        ZonaAmortecimentoUnidadeConservacaoPi,
        Queimadas,
        SitiosArqueologicos,
        FaixaFronteira,
        PocAreaPlantadaGameleira,
        ImovelRural,
        Biomas,
        IncraSigefPublico,
        IncraSigefPrivado,
        IncraAssentamentos,
        IncraQuilombolas,
        ElegibilidadeRenovabio,
        DesmatamentoMapbiomas,
        DesmatamentoMapbiomasSad,
        Fonte,
        AreaRelevanteInteresseEcologicoArie,
        AreaProtecaoAmbientalApa,
        AppCamada,
        ReservaLegal,
        UnidadeConservacao,
        AreaPlantadaSojaCarMapbiomas,
        AutoInfracaoSigamSp,
        FundacaoPalmares,
        AreasPrioritarias,
        MonitoramentoDesmatamento,
        AreaEmbargadaSedamRo,
        AreaEmbargadaRo,
        AreaEmbargadaRoPonto,
        PlantioSoja23Matopiba,
        SojaParaguai,
        RecursoNaturalParaguai,
        ConformidadeSocioambientalParaguai,
        DesmatamentoInfonaParaguai,
        AreasSilvestresProtegidasParaguai,
        ListaAreaEmbargadaPiaui,
        FlorestasPublicas,
        ProdesCaatinga,
        ProdesMataAtlantica,
        ProdesPampa,
        ProdesPantanal,
        AreaEmbargadaSigaMtPoligono,
        AreaEmbargadaSigaMtPonto,
        ListaAreaEmbargadaSemaMt,
        ProdesResiduos,
        ProdesResiduosAmazonia,
        ProdesResiduosCaatinga,
        ProdesResiduosCerrado,
        ProdesResiduosMataAtlantica,
        ProdesResiduosPampa,
        ProdesResiduosPantanal,
        BaseButton,
        DesmatamentoEudr,
        ArLocalidadeNivel1,
        ArLocalidadeNivel2,
        BrLocalidadeNivel1,
        BrLocalidadeNivel2,
        DesmatamentoGfwParaguai,
        Soja2022DesmatamentoInfonaParaguai,
        Soja2022AreasProtegidasParaguai,
        Soja2022ReservaBiosferaParaguai,
        Soja2022TerrasIndigenasParaguai,
        Soja2022SitiosRamsarParaguai,
        AreaEmbargadaIbamaPoligonoPamgia
    },

    computed: {
        ...mapGetters(['usuarioLogado'])
    },

    props: {
        dadosConsulta: {
            type: Object | null,
            required: true
        },
        inspecionar: {
            type: Boolean,
            required: false,
            default: false
        },

        indexCollapse: {
            type: Number,
            required: false,
            default: 0
        },

        cpfCnpj: {
            type: String,
            required: false,
            default: null
        },

        car: {
            type: String,
            required: false,
            default: null
        },

        habilitarSinalAviso: {
            type: Boolean,
            required: false,
            default: false
        },

        habilitarInibicaoCamada: {
            type: Boolean,
            required: false,
            default: false
        },
        habilitarOpacidade: {
            type: Boolean,
            required: false,
            default: false
        },
        mapaLeaflet: {
            type: Object,
            required: false,
            default: null
        },
        habilitarZoomRestricao: {
            type: Boolean,
            required: false,
            default: false
        },
        fecharCollapses: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            indexCollapseRow: '',
            possuiResultados: false,
            camadasUsuario: [],
            loadingCertidaoIbama: false,
            camadasForaDaRegiao: []
        };
    },

    watch: {
        indexCollapseRow: function () {
            if (this.mapaLeaflet) {
                this.mapaLeaflet.aplicarZoomGeoJson(null);
            }

            this.$emit(
                'index-aberto',
                null,
                this.indexCollapse,
                this.indexCollapseRow
            );
        },
        dadosConsulta: function () {
                this.possuiResultados = false;
                this.filtrarCamadas();
        }
    },

    async mounted() {
        this.filtrarCamadas();
        try {
            const { data } = await CamadasService.buscarCamadasUsuario();
            this.camadasUsuario = data;

            if (this.inspecionar) {
                this.indexCollapseRow = Array.from(
                    { length: this.camadasUsuario.length },
                    (_, index) => index
                );
            }
            if (this.dadosConsulta && this.dadosConsulta.diagnostico) {
                this.dadosConsulta.diagnostico.forEach(diagnosticoCamada => {
                    diagnosticoCamada.resultados.forEach(item => {
                        item.selecionado = false;
                    });
                });
            }
        } catch (error) {
            this.$notify.error(
                this.$t('mensagens.diagnosticoSocioambiental.erro.buscarCamadasDoUsuario')
            );
        }

        this.conectarWebsocket();
    },

    beforeDestroy() {
        disconnect();
    },

    created: function () {
        if (this.fecharCollapses) {
            EventBus.$on('fecharCollapses', this.fecharTodos);
        }
    },

    methods: {
        inibirRestricao(restricao, diagnostico) {
            this.$emit('inibir-restricao', restricao, diagnostico);
        },
        formatarData(data) {
            if (!data) return '';

            if (data.includes(' ')) {
                data = data.split(' ')[0];
            }
            
            if (data.includes('T')) {
                const [year, month, day] = data.split('T')[0].split('-');
                return `${day}/${month}/${year}`;
            }
            
            if (data.includes('-')) {
                const [year, month, day] = data.split('-');
                return `${day}/${month}/${year}`;
            }
            
            return data;
        },
        fecharTodos() {
            this.indexCollapseRow = null;
        },
        async marcarRestricaoParaInibir(diagnostico) {
            const restricoesSelecionadas = diagnostico.resultados.filter(
                item => item.selecionado
            );

            if (
                restricoesSelecionadas.length > 0 &&
                restricoesSelecionadas.length === diagnostico.resultados.length
            ) {
                diagnostico.marcarTodasRestricoes = true;
                diagnostico.todasRestricoesIndeterminadas = false;
            } else if (restricoesSelecionadas.length > 0) {
                diagnostico.marcarTodasRestricoes = false;
                diagnostico.todasRestricoesIndeterminadas = true;
            } else {
                diagnostico.marcarTodasRestricoes = false;
                diagnostico.todasRestricoesIndeterminadas = false;
            }

            this.$forceUpdate();
        },

        marcarTodasRestricoes(diagnostico) {
            diagnostico.todasRestricoesIndeterminadas = false;

            diagnostico.resultados.forEach(item => {
                if (!item.inibido) {
                    item.selecionado = diagnostico.marcarTodasRestricoes;
                }
            });

            this.$forceUpdate();
        },

        habilitarInibicao(nivel) {
            return this.habilitarInibicaoCamada && nivel === 'ALTO';
        },

        existeRestricaoNaoInibida(diagnostico, atualizarPagina) {
            if (atualizarPagina) {
                return !atualizarPagina;
            }
            return diagnostico.resultados.find(restricao => !restricao.inibido && (restricao.properties?.nivelAlerta === 'ALTO' || restricao.nivelAlerta === 'ALTO'));
        },

        verificarRestricaoInibidaAutomaticamente(diagnostico) {
            if (diagnostico.resultados && diagnostico.resultados.length > 0) {
                let quantidadeNivelAlto = diagnostico.resultados.filter(restricao => restricao.properties?.nivelAlerta === 'ALTO' || restricao.nivelAlerta === 'ALTO').length;
                if (quantidadeNivelAlto > 0) {
                    return quantidadeNivelAlto === diagnostico.resultados.filter(restricao => restricao.inibidoAutomaticamente).length;
                }
            }

            return false;
        },

        inibirRestricoesEmLote(diagnostico) {
            const restricoesSelecionadas = diagnostico.resultados.filter(
                item => item.selecionado && !item.inibido && (item.properties?.nivelAlerta === 'ALTO' || item.nivelAlerta === 'ALTO')
            );

            if (restricoesSelecionadas.length > 0) {
                this.$emit(
                    'inibir-restricoes-em-lote',
                    restricoesSelecionadas,
                    diagnostico
                );
            } else {
                this.$notify.error({
                    message: this.$t('mensagens.diagnosticoSocioambiental.erro.selecioneAoMenosUmaRestricao')
                });
            }
        },

        verificaPerfilBotaoJustificativa() {
            return (
                this.$store.state.usuarioLogado.isAdmin ||
                this.$store.state.usuarioLogado.operacaoAprovador ||
                this.$store.state.usuarioLogado.operacaoCdaWaCadastrante
            );
        },

        verificaPerfilBotaoInibir() {
            return (
                this.$store.state.usuarioLogado.isAdmin ||
                this.$store.state.usuarioLogado.operacaoCdaWaCadastrante
            );
        },

        ehRestricaoInibida(restricao) {
            return restricao.inibido;
        },

        exibirBotaoInibir(restricao) {
            return !restricao.inibido && (restricao.properties?.nivelAlerta === 'ALTO' || restricao.nivelAlerta === 'ALTO');
        },

        atualizarOpacidade(opacidade) {
            const group = `grupo-restricoes-${this.indexCollapse}-${this.indexCollapseRow}`;
            const layers = Object.values(this.mapaLeaflet.mapa._layers).filter(
                l => l.group === group
            );
            if (layers) {
                const novaOpacidade = opacidade >= 0 ? opacidade / 200 : 0.5;
                layers.forEach(layer => {
                    this.mapaLeaflet.mapa.removeLayer(layer);
                    layer.options.fillOpacity = novaOpacidade;
                    layer.options.opacity = novaOpacidade;
                    this.mapaLeaflet.mapa.addLayer(layer);
                });
            }
        },

        getCamadasForaDaRegiao() {
            if (this.dadosConsulta) {
                let diagnosticos =
                this.dadosConsulta.diagnostico ||
                this.dadosConsulta.diagnosticos ||
                [];
                return diagnosticos.filter(d => d.status === 'OUTSIDE_REGION');
            } else {
                return [];
            }
        },

        getDiagnosticos() {
            const diagnosticos = this.dadosConsulta?.diagnostico || this.dadosConsulta?.diagnosticos || [];

            diagnosticos.forEach(diagnostico => {
                diagnostico.codigo = this.dadosConsulta.codigo;
            });

            return diagnosticos;
        },

        filtrarCamadas() {
            if (this.dadosConsulta && this.dadosConsulta.diagnostico) {
                this.dadosConsulta.diagnostico =
                    this.dadosConsulta.diagnostico.filter(
                        ({ camada, status }) =>
                            camada.codigo !== 'APP_DEGRADADA'
                    );
            } else if (this.dadosConsulta && this.dadosConsulta.diagnosticos) {
                this.dadosConsulta.diagnosticos =
                    this.dadosConsulta.diagnosticos.filter(
                        ({ camada, status }) =>
                            camada.codigo !== 'APP_DEGRADADA'
                    );
            }
        },

        showLayer(diagnostico) {
            if (diagnostico) {
                if (diagnostico.status === 'OUTSIDE_REGION') {
                    return false;
                } else {
                    const show = this.inspecionar
                        ? this.camadasUsuario.includes(
                              diagnostico.camada.codigo
                          ) && diagnostico.resultados.length > 0
                        : camadasDiagnostico.includes(
                              diagnostico.camada.codigo
                          );
                    if (show) {
                        this.possuiResultados = true;
                    }
                    return show;
                }
            }

            return false;
        },

        showLayerResults(diagnostico) {
            if (diagnostico && diagnostico.resultados.length) {

                if (diagnostico.resultados.length === 1 && diagnostico.resultados[0].id === null) {
                    return false;
                }
        
                if (diagnostico.camada.codigo === 'APP') {
                    diagnostico.component = 'app-camada';
                } else if (diagnostico.camada.codigo === 'SITUACAO_CAR_SANTANDER') { // TODO: [OPERACAO] Código SITUACAO_CAR_SANTANDER é antigo, remover quando corrigir todo passivo.
                    diagnostico.component = 'situacao-car';
                } else if (diagnostico.camada.codigo.includes('ELEGIBILIDADE_RENOVABIO')) {
                    diagnostico.component = 'elegibilidade-renovabio';
                } else if (diagnostico.camada.codigo === 'SOJA_PARAGUAI_2022') {
                    diagnostico.component = 'soja-paraguai';
                } else if (diagnostico.camada.codigo === 'BOSQUE_NATIVO_PARAGUAI' || diagnostico.camada.codigo === 'PALMAR_PARAGUAI') {
                    diagnostico.component = 'recurso-natural-paraguai';
                } else if (diagnostico.camada.codigo === 'SITIO_RAMSAR_PARAGUAI' || diagnostico.camada.codigo === 'RESERVA_BIOSFERA_PARAGUAI') {
                    diagnostico.component = 'conformidade-socioambiental-paraguai';
                } else if (diagnostico.camada.codigo.includes('AREA_PLANTADA_SOJA_CAR_MAPBIOMAS')) {
                    diagnostico.component = 'area-plantada-soja-car-mapbiomas';
                } else {
                    diagnostico.component = diagnostico.camada.codigo
                        .toLowerCase()
                        .replaceAll('_', '-');
                }
                return true;
            }
            return false;
        },

        getProperties(diagnostico) {
            return {
                restricoes: diagnostico.resultados,
                geometria: diagnostico.geometria,
                habilitarZoomRestricao: this.habilitarZoomRestricao,
                cpfCnpj: this.cpfCnpj
            };
        },

        openIbamaNewTab() {
            navigator.clipboard.writeText(this.cpfCnpj);
            this.$notify.success({
                message: 'O texto pesquisado foi copiado para sua área de transferência, você está sendo direcionado para o site do Ibama'
            });

            setTimeout(() => {
                window.open('https://servicos.ibama.gov.br/ctf/publico/areasembargadas/', '_blank');
            }, 3000);
        },

        async getCertidao() {
            const fmtCpfCnpj = this.cpfCnpj
                .replaceAll('-', '')
                .replaceAll('.', '')
                .replaceAll('/', '');

            try {
                this.loadingCertidaoIbama = true;
                this.$notify.info({
                    message: this.$t('mensagens.diagnosticoSocioambiental.arquivoFoiSolicitado'),
                    duration: 15000
                });
                await CertidaoIbamaService.buscarCertidao(fmtCpfCnpj);
            } catch (error) {
                this.loadingPlanilha = false;
                this.$notify.error({
                    message: this.$t('mensagens.diagnosticoSocioambiental.erro.erroAoGerarCertidao')
                });
            }
        },

        async getCertidaoLdi() {
            const url = `https://monitoramento.semas.pa.gov.br/ldi/imoveis/downloadcertidaodesmatamento?codigoImovel=${this.car}`;
            window.open(url, '_blank');
        },

        definirNomeCamada(diagnostico) {
            const camada = diagnostico.camada;

            let nomeCamada = this.$t(`mensagens.camadas.${camada.codigo}`);

            if ((diagnostico.codigo === 'PROXIMIDADE_CAR_ANALISADO' || diagnostico.codigo === 'PROXIMIDADE_TERRITORIO_ANALISADO' || diagnostico.codigo === 'PROXIMIDADE_GLEBA_ANALISADA') && diagnostico.bufferMetros) {
                const bufferKm = (diagnostico.bufferMetros / 1000);
                nomeCamada += ` (<strong>${bufferKm} km</strong>)`;
            }

            return nomeCamada;
        },

        podeHabilitarOpacidade(diagnostico) {
            let podeHabilitar = false;

            /**
             * Caso a props esteja 'false'
             * o componente de opacidade não vai ser exibido
             */
            if (!this.habilitarOpacidade) {
                return podeHabilitar;
            }

            /**
             * Caso exista apenas uma restrição
             * e essa restrição esteja sem geometria
             * não vai ser exibido o componente de opacidade
             */
            if (diagnostico && diagnostico.resultados.length) {
                const totalRestricoesSemGeometria =
                    diagnostico.resultados.filter(
                        r => r.geometry === undefined || r.geometry === null
                    ).length;
                if (
                    totalRestricoesSemGeometria !==
                    diagnostico.resultados.length
                ) {
                    podeHabilitar = true;
                }
            }

            return podeHabilitar;
        },

        montaClasseCamada(inspecionar, habilitarSinalAviso) {
            let classe = '';
            if (inspecionar) {
                classe += ' font-weight-bold';
            }
            if (habilitarSinalAviso) {
                classe = +' ml-2';
            }

            return classe;
        },

        aplicarZoomRestricao(
            restricao,
            geometriaQueNaoEstavaDentroDasRestricoes
        ) {
            let geoJson = geometriaQueNaoEstavaDentroDasRestricoes;

            if (
                typeof restricao.properties === 'object' &&
                restricao.properties
            ) {
                if (restricao.properties.geometry) {
                    geoJson = restricao.properties.geometry;
                }

                if (restricao.properties.geometria) {
                    geoJson = restricao.properties.geometria;
                }
            }

            if (
                typeof restricao.propriedade === 'object' &&
                restricao.propriedade
            ) {
                if (restricao.propriedade.geometry) {
                    geoJson = restricao.propriedade.geometry;
                }

                if (restricao.propriedade.geometria) {
                    geoJson = restricao.propriedade.geometria;
                }
            }

            if (restricao.geometry) {
                geoJson = restricao.geometry;
            }
            if (restricao.geometria) {
                geoJson = restricao.geometria;
            }

            this.mapaLeaflet.aplicarZoomGeoJson(geoJson);
        },

        async conectarWebsocket() {
            try {
                await connect();
            } catch {
                this.$notify.error({
                    message: this.$t('mensagens.diagnosticoSocioambiental.erro.naoFoiPossivelConectarApi')
                });
                return;
            }

            try {
                subscribe(
                    `${this.usuarioLogado.idKeyCloack}/gerar/certidao-ibama`,
                    response => {
                        if (response && response.length > 0) {
                            const linkSource = `data:application/pdf;base64,${response}`;
                            const link = document.createElement('a');
                            const fileName = 'Certidao-Ibama.pdf';
                            link.href = linkSource;
                            link.download = fileName;
                            link.click();
                            link.remove();
                            this.loadingCertidaoIbama = false;
                        } else {
                            this.loadingCertidaoIbama = false;
                            this.$notify.error({
                                message: this.$t('mensagens.diagnosticoSocioambiental.erro.naoFoiPossivelGerarCertidao')
                            });
                        }
                    }
                );
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.diagnosticoSocioambiental.erro.naoFoiPossivelGerarCertidao')
                });
            }
        }
    }
};
</script>

<style lang="scss">
#diagnostico-socioambiental .container-restricao {
    .card-restricao {
        background-color: #fafafa;
        border: 1px solid #eaeefb;
        border-radius: 4px;
        padding: 10px 10px 0px 20px;
        margin-bottom: 20px;
    }

    .card-restricao--ativo {
        border: 1px solid var(--primary);
    }

    .container-restricao-acoes {
        display: block;
        margin-bottom: 8px
    }

    .card-restricao {
        padding-top: 48px;
    }

    .card-restricao:has(.container-restricao-acoes) {
        padding-top: 10px;
    }
}

.container-botoes {
    margin-bottom: 10px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.icons-position {
    display: flex;
    align-content: center;
    align-items: center;
}

.el-collapse {
    width: 100%;
}

.vermelho {
    color: red;
}

.amarelo {
    color: #d7bc25;
}

.verde {
    color: green;
}

.tag-inibido-automaticamente {
    border: 1px solid var(--tag-success-border);
    background-color: var(--tag-success-background);
    color: var(--tag-success-text);
    border-radius: 5px;
    text-align: center;
    font-size: 13px;
    font-weight: normal !important;
    padding: 3px;
}

.certidao {
    color: var(--white) !important;
    background: var(--primary) !important;
}

.custon-tag {
    border-radius: 12px;
    margin-left: 5px;
}

.custon-icon {
    font-size: 16px;
}

.custon-icon-el {
    font-size: 18px;
}

.el-tag--mini {
    height: 17px !important;
    padding: 0 5px !important;
    line-height: 17px !important;
    border-radius: 10px !important;
}

.botao-inibir-restricao {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 2%;
    margin-top: -40px;
    align-items: center;

    .checkbox-adjust {
        margin-top: 7px !important;
    }

    .botao-inibir-restricao--nao-inibido {
        margin-right: 10px;
    }
}

.botao-inibir-em-lote {
    display: flex;
    justify-content: flex-end;
}

.camada-inibida {
    background: #f2f2f2;
    border-radius: 5px;
    padding: 10px 15px;
    margin-bottom: 15px;
}

.card-opacidade {
    margin-bottom: 20px !important;
    word-wrap: break-word !important;
    background-color: #fff !important;
    background-clip: border-box !important;
    border: 1px solid rgba(0, 0, 0, 0.13) !important;
    border-radius: 0.25rem !important;
    padding: 5px !important;

    .opacidade {
        display: block;
        padding: 0 20px;

        span {
            font-weight: bolder;
        }

        .el-slider {
            width: 97%;
            height: 20px;
        }
    }

    .container-justificativa {
        margin-bottom: 30px !important;
        height: 300px !important;
    }
}

.criterio {
    background-color: #eaeefb;
    padding: 5px 100px 5px 5px;
    width: 100%;
    display: block;
    font-size: 16px;
    border-radius: 5px;
    margin-bottom: 10px;
}
.tooltip-content {
    width: 250px;
}
.tooltip-camadas {
    font-size: 13px;
}
.tooltop-container {
    text-align: right;
}

.lyra-seguir-link {
    cursor: pointer;
    content: '';
    width: 14px;
    height: 14px;
    display: inline-block;
    -webkit-mask: url(../../assets/lyra-icons/svg/flecha-seguir.svg) no-repeat 50% 50%;
    mask: url(../../assets/lyra-icons/svg/flecha-seguir.svg) no-repeat 50% 50%;
    mask-size: cover;
    -webkit-mask-size: cover;
    background-color: var(--link);
    color: var(--link);
}

.link-button {
    color: var(--link);
    display: flex;
    justify-content: right;
    align-items: center;
    cursor: pointer;
    font-size: 14px !important;
}

.link-button:hover {
    text-decoration: underline;
}
</style>
